import Storage from 'vue-ls';
const options = {
  namespace: '28zhe_',
  name: 'ls',
  storage: 'local',
};

const {
  ls
} = Storage.useStorage(options)

export default ls